import { useState } from "react";
import { Checkbox, List, Loader } from "semantic-ui-react";
import { patchUser } from "../api/GlobalApi";
import { patchMockUser } from "../api/mock/MockGlobalApi";
import { handleErrorResponse } from "../Helpers";
import { handleApiPromise } from "../helpers/GlobalHelper";
import { UserFeatureFlags } from "./constants/GlobalConstants";
import { DefaultFeatureFlags } from "./constants/LocalServerConstants";

const BCFeatureFlags = ({ user, setIsMessage, setErrorResponse }) => {
  const [isLoading, setIsLoading] = useState(false as boolean);
  const handleFeatureFlagChanged = async (flag) => {
    setIsLoading(true);
    let userPreferencesFeatureFlags = {};
    if (user?.preferences?.featureFlags) {
      userPreferencesFeatureFlags = user.preferences.featureFlags;
    }

    const userFeatureFlags = {};
    UserFeatureFlags.forEach(flag => {
      userFeatureFlags[flag.name] = DefaultFeatureFlags[flag.name];
    });

    if (Object.keys(userPreferencesFeatureFlags).find(x => x === flag)) {
      userFeatureFlags[flag] = !userPreferencesFeatureFlags[flag];
    }
    else {
      userFeatureFlags[flag] = !DefaultFeatureFlags[flag];
    }

    if (!user?.preferences) {
      user.preferences = {};
    }

    user.preferences.featureFlags = userFeatureFlags;
    const patchObj = {
      id: user.profileId,
      preferences: JSON.stringify(user.preferences)
    };

    await handleApiPromise(
      () => patchUser(patchObj),
      () => patchMockUser(patchObj),
      (response) => handleErrorResponse(response, setIsMessage, setErrorResponse),
      false
    ) || [];
    
    setIsLoading(false);
  };

  const handleFindFeatureFlag = (flag) => {
    if (user?.preferences?.featureFlags) {
      return user.preferences.featureFlags[flag];
    }
    else if (DefaultFeatureFlags[flag]) {
      return DefaultFeatureFlags[flag];
    }

    return false;
  };

  return (
    <>
      {isLoading ? <Loader active inline="centered" size={"big"} /> : <List>
        {UserFeatureFlags.map((flag) => {
          return (
            <List.Item>
              <Checkbox 
                key={`flag-${flag.name}`} 
                checked={handleFindFeatureFlag(flag.name)}
                toggle
                label={flag.name} 
                onChange={() => handleFeatureFlagChanged(flag.name)} 
              />
              <div>{flag.description}</div>
            </List.Item>
          );
        })}
      </List>}
    </>
  );
};

export default BCFeatureFlags; 